<template>
  <div class="sample-type-dropdown" ref="dropdownContainer">
    <div class="dropdown-container">
      <label for="custom-dropdown" class="dropdown-label"> {{$tI_G('Filter by location dropdown title')}} </label>
      <div class="select-custom-dropdown">
        <div class="dropdown-select" @click="toggleDropdown">{{ $t(selectedLocation) || $tI('All Locations') }}</div>
        <div class="custom-dropdown-menu cs-scroll-style" v-if="isDropdownOpen">
          <div 
            v-for="(item, index) in locationList" 
            :key="index" 
            class="custom-dropdown-item" 
            @click="selectLocation(item)"
            v-click-track="'Iframe.ancientDnaSampleDatabaseFilteredByLocation'"
          >
            {{ item === '' ? $tI('All Locations') : $t(item) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    modalObject: {
      type: Object,
    },
    callback: {
      type: Function,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      isDropdownOpen: false,
    }
  },
  methods: {
    applySelectedLocation() {
      this.$store.commit('sampleDatabase/setDefaultQuery')
      this.$store.state.sampleDatabase.filterQuery.location = this.selectedLocation;
    },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectLocation(item) {
      this.isDropdownOpen = false;
      this.$store.state.sampleDatabase.filterQuery.location = item;
    },    
    
    closeDropdown(event) {
      if (!this.$refs.dropdownContainer.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    },
  },
  computed: {
    locationList() {
      return this.$store.state.sampleDatabase.locationList;
    },
    selectedLocation() {
      return this.$store.state.sampleDatabase.filterQuery.location;
    }
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown);
  },
};
</script>

<style lang="scss" scoped>
.sample-type-dropdown {
  .dropdown-container {
    padding: 0;
    width: 100%;

    .select-custom-dropdown {
      width: 100%;
    }
  }
}

</style>
